(() => {
	if (customElements.get('products-slider')) {
		return;
	}

	class CartCrossSlider extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.swiper = new Swiper(this, {
				slidesPerView: 1,
				spaceBetween: 8,
				navigation: {
					nextEl: this.querySelector('[data-next]'),
					prevEl: this.querySelector('[data-prev]'),
					enabled: false
				},
				pagination: {
					el: '[data-pagination]',
					clickable: true,
					enabled: true,
					dynamicBullets: true,
					dynamicMainBulltes: 1
				},
				breakpoints: {
					480: {
						navigation: {
							enabled: true
						},
						pagination: {
							enabled: false
						}
					},
					320: {
						navigation: {
							enabled: false
						},
						pagination: {
							enabled: true
						}
					}
				}
			})
		}
	}

	customElements.define('products-slider', CartCrossSlider);
})();
